import React from 'react';
import { Layout, Result, Button } from 'antd';
import AppHeader from '../../components/Header';
import AppFooter from '../../components/Footer';
import { Link } from 'react-router-dom';
import './index.css';

const { Content } = Layout;

const NotFound = ({ loggetInUser, onLogout }) => {
    // 生成装饰元素
    const renderDecorations = () => {
        return (
            <div className="notfound-decorations">
                <div className="decoration-circle"></div>
                <div className="decoration-circle"></div>
                <div className="decoration-circle"></div>
                <div className="decoration-triangle"></div>
                <div className="decoration-triangle"></div>
                <div className="notfound-code">
                    {Array.from({ length: 50 }).map((_, i) => (
                        <span key={i} style={{ animationDelay: `${Math.random() * 10}s` }}>
                            {Math.random() > 0.5 ? '1' : '0'}
                        </span>
                    ))}
                </div>
            </div>
        );
    };

    // 搜索建议链接
    const suggestions = [
        { label: '返回首页', path: '/' },
        { label: '文章归档', path: '/archive' },
        { label: '关于作者', path: '/about' },
        { label: '热门文章', path: '/archive?sort=hot' },
        { label: '技术分类', path: '/archive?category=前端开发' },
        { label: '联系作者', path: '/contact' }
    ];

    return (
        <Layout className="blog-layout">
            <AppHeader loggetInUser={loggetInUser} onLogout={onLogout} />
            <Content className="blog-content notfound-content">
                {renderDecorations()}
                <Result
                    status="404"
                    title="页面走丢了"
                    subTitle="很抱歉，您访问的页面不存在或已被移动。"
                    extra={
                        <Link to="/">
                            <Button type="primary">🚀 返回首页</Button>
                        </Link>
                    }
                />
                
                <div className="notfound-suggestions">
                    <div className="suggestions-title">或许您可以试试这些链接：</div>
                    <div className="suggestions-list">
                        {suggestions.map((item, index) => (
                            <Link 
                                key={index} 
                                to={item.path} 
                                className="suggestion-item"
                            >
                                {item.label}
                            </Link>
                        ))}
                    </div>
                </div>
            </Content>
            <AppFooter />
        </Layout>
    );
};

export default NotFound;